import React from 'react'
import { BrowserRouter as Router, Routes, Route, redirect } from "react-router-dom";
import { Navigate } from 'react-router-dom';

import Navbar from "./Navbar/Navbar"
import Footer from './Footer/Footer';
import ScrollToTop from './Util/ScrollToTop';
import SeoManager from './Util/Seo';

import Home from './Home/Home';

import Invest from './Invest/Invest';
import Recruitment from './Recruitment/Recruitment';
import NotFound from './NotFound/NotFound'

import AboutUs from './AboutUs/AboutUs';
import Contact from './Contact/Contact';
import ContactZh from './ContactZh/ContactZh';
import Purchase from './Purchase/Purchase';
import Distribution from './Distribution/Distribution';

import "./styles/animations.css"
import "./styles/fonts.css"
import "./styles/main.css"

import ScrollToTopButton from './Util/ScrollToTopButton';
import { useLanguage } from './Context/LanguageContext';
import AboutUsZh from './AboutUsZh/AboutUsZh';
import Visa from './Visa/Visa';
import Imprint from './Legal/Imprint/Imprint';
import Trade from './Trade/Trade';
import PrivacyPolicy from './Legal/Privacy/Privacy';
import BusinessServices from './Business/Business';


function App() {
  const {language} = useLanguage()

  return (
      <Router>
        <SeoManager/>
        <ScrollToTop/>
        <ScrollToTopButton/>
        <Navbar/>

        <main>
            {language !== "zh" ? 
              <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/invest" element={<Invest />} />
                <Route path="/recruitment" element={<Recruitment />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/purchase" element={<Purchase />} />
                <Route path="/distribution" element={<Distribution />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            : 
              <Routes>
                <Route path="/" element={<AboutUsZh />} />
                <Route path="/contact" element={<ContactZh />} />
                <Route path="/visa-consulting" element={<Visa />} />
                <Route path="/business" element={<BusinessServices />} />
                <Route path="/international-trade" element={<Trade />} />
                <Route path="/imprint" element={<Imprint />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />

                <Route path="*" element={<NotFound />} />
              </Routes>
            }
        </main>

        <Footer/>
      </Router>
  );
}

export default App;
